import { Wallet } from "../../../types/wallet";

export const filterDisabledWalletsOut = (wallet: Wallet) => {
    return wallet.provider.enabled;
}